// import { UserService, AuthenticationError } from '../services/user.service'
import TokenService from '../services/storage.service'
// import router from '../router'
import Vue from 'vue'

const state = {
    id: null,
    name: '',
    roles: [],
    active: 0
}

const getters = {
    id: state => state.id,
    name: state => state.name,
    roles: state => state.roles,
    active: state => state.active
}

const actions = {
    setUserData( { commit } ) {
        const jwtToken = TokenService.getToken()
        if ( jwtToken ) {
            const base64Url = jwtToken.split( '.' )[ 1 ]
            const base64 = base64Url.replace( '-', '+' ).replace( '_', '/' )
            commit( 'setUserData', JSON.parse( window.atob( base64 ) ) )
        }
    }
}

const mutations = {
    setUserData( state, user ) {
        Vue.set( state, 'id', user.id )
        Vue.set( state, 'name', user.name )
        Vue.set( state, 'roles', user.roles )
        Vue.set( state, 'active', user.active )
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
